import React from 'react'
import ContentLoader from 'react-content-loader'

const ServiceInformationQuickViewContentSkeleton = () => (
  <ContentLoader width={470} height={650} speed={2} primaryColor='#dadada' secondaryColor='#d4d3d3'>
    <rect x='0' y='0' height='17' width='191' />
    <rect x='0' y='21' height='17' width='470' />
    <rect x='0' y='42' height='17' width='470' />
    <rect x='0' y='63' height='17' width='200' />

    <rect x='0' y='94' height='17' width='67' />
    <rect x='0' y='125' height='17' width='470' />
    <rect x='0' y='146' height='17' width='400' />

    <rect x='0' y='177' height='17' width='80' />
    <rect x='0' y='208' height='17' width='470' />
    <rect x='0' y='229' height='17' width='200' />
    <rect x='0' y='250' height='17' width='300' />

    <rect x='0' y='281' height='17' width='153' />
    <rect x='16' y='302' height='17' width='454' />
    <rect x='16' y='323' height='17' width='454' />
    <rect x='16' y='344' height='17' width='454' />
    <rect x='16' y='363' height='17' width='454' />
    <rect x='16' y='384' height='17' width='50' />

    <rect x='16' y='405' height='17' width='454' />
    <rect x='16' y='426' height='17' width='454' />
    <rect x='16' y='447' height='17' width='400' />

    <rect x='16' y='468' height='17' width='454' />
    <rect x='16' y='489' height='17' width='400' />

    <rect x='16' y='510' height='17' width='454' />
    <rect x='16' y='531' height='17' width='50' />

    <rect x='0' y='552' height='17' width='300' />
  </ContentLoader>
)

export default ServiceInformationQuickViewContentSkeleton
